import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import Home from '@/views/Home.vue'
import Category from '@/views/Category.vue'
import Tags from '@/views/Tags.vue'
import Sorted from '@/views/Sorted.vue'
import Me from '@/views/Me.vue'
import BlogDetail from '@/views/BlogDetail.vue'
import ConditionBlogs from '@/views/ConditionBlogs.vue'

// eslint-disable
const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: '/home',
    meta:{
      hideInHeader: true
    }
  },
  {
    path: '/home',
    name: 'Home',
    component: Home
  },
  {
    path: '/category',
    name: 'Category',
    component: Category
  },
  {
    path: '/tags',
    name: 'Tags',
    component: Tags
  },
  {
    path: '/sorted',
    name: 'Sorted',
    component: Sorted
  },
  {
    path: '/me',
    name: 'Author',
    component: Me
  },
  {
    path: '/blog/:blogId',
    name: 'BlogDetail',
    component: BlogDetail,
    meta:{
      hideInHeader: true
    }
  },
  {
    path: '/condition',
    name: 'ConditionBlogs',
    component: ConditionBlogs,
    meta:{
      hideInHeader: true
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

export default router
